import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../components/Title";
import { CreateTwoTone, DeleteOutlineRounded, Settings, GetApp } from "@material-ui/icons";
import UserService from "../../services/UserService";
import { DataGrid } from '@material-ui/data-grid';
import Message from "../tools/Message";
import ConfirmationDialog from "../tools/ConfirmationDialog";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { useNavigate, useLocation } from 'react-router-dom';
import { hasPrivilege } from "../../utils/privilege";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import SpecialSettingDialog from "./SpecialSettingDialog";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { TextField, MenuItem, Select, InputLabel, FormControl, Grid } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as XLSX from 'xlsx'; // Ajouter cette importation

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  exportButton: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function StagiaireTable(props) {

  const navigate = useNavigate();
  const location = useLocation();
  const iddir = props.dir;
  const idservice = props.idservice;
  const type = props.type;

  const [rows, setRows] = useState([]);
  const [userInfo, setUserInfo] = useState("");
  const classes = useStyles();
  const [isid, setIsid] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'voulez vous supprimer?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    openMessage: false,
    color: 'green',
    messageInfo: '',
  });
  const { openMessage, color, messageInfo } = message;
  const contextData = useContext(userDetailContext);
  const [openSpecialSettingDialog, setOpenSpecialSettingDialog] = React.useState(false);
  const [dialoguesdesactivation, setDialoguesdesactivation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [idValidatorNumber, setIdValidatorNumber] = useState(0);
  const [validatorNumber, setValidatorNumber] = useState("");
  const [validatorNumberMission, setValidatorNumberMission] = useState("");
  const [id, setId] = useState("");
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const [formData, setFormData] = useState({
    endDate: '',
    deactivationType: 'Fin de stage'
  }); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Fonction loadAllUser avec useCallback pour éviter les re-créations
  const loadAllUser = useCallback(() => {
    setOpenLoadingSimpleBackdrop(true);
    UserService.getListstg(iddir, idservice, type).then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
      } else {
        setRows([]);
      }
      setOpenLoadingSimpleBackdrop(false);
    }).catch((error) => {
      console.error("Error loading users:", error);
      setRows([]);
      setOpenLoadingSimpleBackdrop(false);
    });
  }, [iddir, idservice, type]);

  useEffect(() => {
    loadAllUser();
  }, [location, iddir, idservice, type, loadAllUser]);

  // Fonction d'export Excel
  const handleExportExcel = () => {
    // Transformer les données pour l'export
    const exportData = rows.map(row => ({
      'Matricule': row.registration_number || '',
      'Direction': row.direction || '',
      'Service': row.service || '',
      'Fonction': row.function_name || '',
      'Nom': row.last_name || '',
      'Prénom': row.first_name || '',
      'Sexe': row.sex_id === "1" ? "Homme" : (row.sex_id === "2" ? "Femme" : ""),
      'Email': row.email || '',
      'Téléphone': row.telephone || '',
      'Groupes': row.group || '',
      'Financement': row.funding || '',
      'Date début de stage': row.date_prise || '',
      'Date fin de stage': row.date_fin || '',
      'Période': row.status || ''
    }));

    // Créer une feuille de calcul
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    
    // Ajuster la largeur des colonnes (optionnel)
    const columnWidths = [
      { wch: 15 }, // Matricule
      { wch: 20 }, // Direction
      { wch: 20 }, // Service
      { wch: 20 }, // Fonction
      { wch: 20 }, // Nom
      { wch: 20 }, // Prénom
      { wch: 10 }, // Sexe
      { wch: 30 }, // Email
      { wch: 15 }, // Téléphone
      { wch: 25 }, // Groupes
      { wch: 20 }, // Financement
      { wch: 20 }, // Date début de stage
      { wch: 20 }, // Date fin de stage
      { wch: 15 }  // Période
    ];
    worksheet['!cols'] = columnWidths;

    // Créer un classeur
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stagiaires');

    // Générer et télécharger le fichier
    const fileName = `Liste_Stagiaires_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const handleDelete = (id) => (ev) => {
    setIsid(id);
    setDialoguesdesactivation(true);
  };

  const handleClose = () => {
    setDialoguesdesactivation(false);
  };

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
  }

  function confirmDialog() {
    setIsLoading(true);
    UserService.updateisactivestg(isid, formData.endDate, formData.deactivationType).then((result) => {
      if (result.status) {
        setIsLoading(false);
        setDialoguesdesactivation(false);
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        loadAllUser();
        setFormData({
          endDate: '',
          deactivationType: ''
        });
      } else {
        setDialoguesdesactivation(false);
        setIsLoading(false);
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
    }).catch((err) => {
      setDialoguesdesactivation(false);
      setIsLoading(false);
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
    });
  }

  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, openMessage: false });
  }

  const handleEdit = (id) => (ev) => {
    navigate("/stglist/add/" + id);
    window.location.reload();
  };

  function handleCloseSettingDialog() {
    setOpenSpecialSettingDialog(false);
  }

  function handleValidate() {
    UserService.saveValidatorNumber(userInfo.user_id, validatorNumber, idValidatorNumber).then((result) => {
      if (result && result.status) {
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
        setOpenSpecialSettingDialog(false);
        loadAllUser();
      }
    });
  }

  function handleChangeNumberOfValidator(ev) {
    const { value } = ev.target;
    const newValue = value.replace(/[^0-9]/g, '');
    setValidatorNumber(newValue);
  }

  function handleChangeNumberOfValidatorMission(ev) {
    const { value } = ev.target;
    const newValue = value.replace(/[^0-9]/g, '');
    setValidatorNumberMission(newValue);
  }

  const handleClickSpecialSetting = (id) => (ev) => {
    setOpenSpecialSettingDialog(true);
    UserService.checkValidatornumberByUserId(id).then((result) => {
      if (result && result.status) {
        setId(id);
        setIdValidatorNumber(result.data.user_validator_number_id);
        setValidatorNumber(result.data.user_validator_number_validatorNumber);
      } else {
        setValidatorNumber(0);
        setId(id);
      }
    });

    UserService.checkValidatornumberByUserIdMission(id).then((res) => {
      if (res && res.status) {
        setValidatorNumberMission(res.data.user_validator_number_validatorNumber);
      } else {
        setValidatorNumberMission(0);
      }
    });

    UserService.getUserSummaryByUserId(id).then((result) => {
      if (result && result.status) {
        setUserInfo(result.data);
      }
    });
  };

  const columns = [
    {
      field: 'registration_number',
      headerName: 'Matricule',
      width: 150,
    },
    {
      field: 'direction',
      headerName: 'Direction',
      width: 150,
    },
    {
      field: 'service',
      headerName: 'Service',
      width: 150,
    },
    {
      field: 'function_name',
      headerName: 'Fonction',
      width: 150,
    },
    {
      field: 'last_name',
      headerName: 'Nom',
      width: 250,
    },
    {
      field: 'first_name',
      headerName: 'Prénom',
      width: 250,
    },
    {
      field: 'sex_id',
      headerName: 'Sexe',
      width: 150,
      valueGetter: (params) => {
        if (params.row.sex_id === "1") return "Homme";
        if (params.row.sex_id === "2") return "Femme";
        return "";
      }
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
    },
    {
      field: 'telephone',
      headerName: 'Téléphone',
      width: 200,
    },
    {
      field: 'group',
      headerName: 'Groupes',
      width: 250,
    },
    {
      field: 'funding',
      headerName: 'Financement',
      width: 200,
    },
    {
      field: 'date_prise',
      headerName: 'Date debut de stage',
      width: 200,
    },
    {
      field: 'date_fin',
      headerName: 'Date fin de stage',
      width: 200,
    },
    {
      field: 'status',
      headerName: 'Période',
      width: 150,
    },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Button onClick={handleEdit(params.id)} title="Modifier un utilisateur">
              <CreateTwoTone style={{ color: "black" }} />
            </Button>
            <Button onClick={handleDelete(params.id)} title="Desactiver un utilisateur">
              <DeleteOutlineRounded style={{ color: "red" }} />
            </Button>

            {hasPrivilege(contextData.privileges, "Other-Me-Validations") && (
              <Button onClick={handleClickSpecialSetting(params.id)} title="Paramètre spécial">
                <Settings style={{ color: "grey" }} />
              </Button>
            )}
          </div>
        );
      },
      width: 200,
    },
  ];

  return (
    <React.Fragment>
      <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} />
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <SpecialSettingDialog openSpecialDialog={openSpecialSettingDialog} handleCloseDialog={handleCloseSettingDialog}
        userInfo={userInfo} handleValidate={handleValidate} validatorNumber={validatorNumber}
        validatorNumberMission={validatorNumberMission} id={id}
        handleChangeNumberOfValidator={handleChangeNumberOfValidator}
        handleChangeNumberOfValidatorMission={handleChangeNumberOfValidatorMission}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title>Listes des stagiaires</Title>
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetApp />}
          onClick={handleExportExcel}
          className={classes.exportButton}
        >
          Exporter Excel
        </Button>
      </div>
      <div style={{ height: "70vh", width: '100%' }} className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 100, 150, 200]}
          disableSelectionOnClick
        />
      </div>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={dialoguesdesactivation}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Confirmation de la désactivation
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
              Êtes-vous sûr de vouloir désactiver?
              <p>Si oui, veuillez renseigner la date exacte de fin de stage.</p>
            </Typography>
            <Grid container spacing={2}>
              {/* Date de fin du contrat */}
              <Grid item xs={12} sm={12}>
                <TextField
                  label="Date exact fin de stage"
                  type="date"
                  fullWidth
                  variant="outlined"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="secondary" autoFocus onClick={handleClose}>
              Annuler
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              autoFocus
              onClick={confirmDialog}
              loading={isLoading}
            >
              Confirmer
            </LoadingButton>
          </DialogActions>
        </BootstrapDialog>
      </div>
    </React.Fragment>
  );
}